import React, { ReactNode, FC, useContext } from 'react';

import ColorSchemeContext from '../../colorScheme/ColorSchemeContext';

import { StyledFooter, StyledFooterContainer } from './AppFooter.styles';

export interface AppFooterProps {
  /** Content of the footer */
  children?: ReactNode;
}

/**
 * @since 0.18.0
 */
const AppFooter: FC<AppFooterProps> = ({ children, ...props }) => {
  const { scheme } = useContext(ColorSchemeContext);

  return (
    <StyledFooter scheme={scheme} data-testid="Appfooter" {...props}>
      <StyledFooterContainer>
        {children}
      </StyledFooterContainer>
    </StyledFooter>
  );
};

export default AppFooter;
